import React from 'react'
import { FRONT, THEME, TRANSLATION } from '../constants/state'
import { compose } from 'underscore'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import Fsk from './Fsk'
import ItemFsk from '../PosterFormatItem/ItemFsk'
import getData from '../functions/getData'


const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    theme: getData(state, THEME), 
    translation: getData(state, TRANSLATION)
})

const FskWrapper = ({fsk, theme, translation, cinemaDataFront, labelFsk=false}) => {
    const {theme_colors} = theme
    const {set_netural_colors_for_fsk} = cinemaDataFront

    return labelFsk ? (
        <ItemFsk 
            fsk={fsk} 
            setNeturalColorsForFsk={set_netural_colors_for_fsk}
            translation={translation} 
        />
    ) : (
        <Fsk
            fsk={fsk} 
            setNeturalColorsForFsk={set_netural_colors_for_fsk}
            translation={translation} 
            theme={theme_colors} 
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(FskWrapper)